var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "slider" }, [
    _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]),
    _vm._v(" "),
    _c("input", {
      staticClass: "sliderInput",
      attrs: { type: "range", min: "0", max: _vm.max },
      domProps: { value: _vm.value },
      on: { change: _vm.handleChange, input: _vm.handleChange },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }